import { jsx as _jsx } from "react/jsx-runtime";
import { useClassifiedId } from "@/contexts/classified";
import { useFavoriteTracking } from "@/hooks";
import { FavoriteHeart } from "@seeker-consumer-portal/favorite-heart";
export const FavoriteCTA = ({ dark, showBorder = false, }) => {
    const classifiedId = useClassifiedId();
    const favoriteTracking = useFavoriteTracking();
    return (_jsx(FavoriteHeart
    // @ts-ignore
    , { 
        // @ts-ignore
        classifiedId: classifiedId, tracking: favoriteTracking, border: showBorder, black: dark }));
};
